import { i18n } from '../i18n';

const WORKFLOW_STAGE_KEYS: Record<string, string> = {
  'Allocation Officer Assignment': 'workflow.designer.defaultStages.allocationOfficerAssignment',
  Closure: 'workflow.designer.defaultStages.closure',
  'Return to Allocation Officer': 'workflow.designer.defaultStages.returnToAllocationOfficer',
  'New Stage': 'workflow.designer.newStage',
};

const WORKFLOW_STEP_STATUS_KEYS: Record<string, string> = {
  Completed: 'tasks.details.legendCompleted',
  'In progress': 'tasks.details.statusInProgress',
  'In Progress': 'tasks.details.statusInProgress',
  Pending: 'tasks.details.legendPending',
};

const CASE_REQUEST_STATUS_KEYS: Record<string, string> = {
  Submitted: 'caseRequests.statusLabels.submitted',
  Draft: 'caseRequests.statusLabels.draft',
  'In Progress': 'caseRequests.statusLabels.inProgress',
  Registered: 'caseRequests.statusLabels.registered',
  Review: 'caseRequests.statusLabels.review',
  Completed: 'caseRequests.statusLabels.completed',
  Rejected: 'caseRequests.statusLabels.rejected',
};

const TASK_STATUS_KEYS: Record<string, string> = {
  'In Progress': 'caseRequests.statusLabels.inProgress',
  'Not Started': 'caseRequests.statusLabels.notStarted',
  Started: 'tasks.details.started',
  Completed: 'caseRequests.statusLabels.completed',
};

const CUSTODY_STATUS_KEYS: Record<string, string> = {
  'Pending document arrival': 'tasks.details.custodyPendingDocumentArrival',
  'Pending Document Arrival': 'tasks.details.custodyPendingDocumentArrival',
};

const DASHBOARD_WORKFLOW_KEYS: Record<string, string> = {
  'Standard prosecution advice': 'dashboards.workflows.standardProsecutionAdvice',
  'Civil review — contract': 'dashboards.workflows.civilReviewContract',
  'Advisory — human rights': 'dashboards.workflows.advisoryHumanRights',
};

export function translateWorkflowStageLabel(label: string): string {
  const trimmed = label.trim();
  const key = WORKFLOW_STAGE_KEYS[trimmed];
  return key ? i18n.t(key) : label;
}

export function translateWorkflowStepStatus(label: string): string {
  const trimmed = label.trim();
  if (!trimmed) return label;
  const key = WORKFLOW_STEP_STATUS_KEYS[trimmed];
  return key ? i18n.t(key) : label;
}

export function translateCaseRequestStatus(status: string): string {
  const trimmed = status.trim();
  const key = CASE_REQUEST_STATUS_KEYS[trimmed];
  return key ? i18n.t(key) : status;
}

export function translateTaskStatus(status: string): string {
  const trimmed = status.trim();
  const key = TASK_STATUS_KEYS[trimmed];
  return key ? i18n.t(key) : status;
}

export function translateCustodyStatus(status: string): string {
  const trimmed = status.trim();
  const key = CUSTODY_STATUS_KEYS[trimmed];
  return key ? i18n.t(key) : status;
}

export function translateDashboardWorkflowLabel(label: string): string {
  const trimmed = label.trim();
  const key = DASHBOARD_WORKFLOW_KEYS[trimmed];
  return key ? i18n.t(key) : label;
}
